import { LOGGED_IN_USER_KEY } from "./constants";

const questions = [
  {
    questionSetId: "person-request-set",
    questions: [
      {
        questionId: "PersonSubmitting",
        question: "What is your relationship to the Consumer?",
        input: {
          type: "radioOptionsInput",
          required: true,
          options: [
            {
              text: "I am the Consumer over the age of 13 years",
              value: "self",
              default: true,
              state: "OK"
            },
            {
              text: "I am the Consumer's Parent or Guardian",
              value: "minor",
              state: "Warning",
              reason: ""
            }
          ]
        },
        validations : [{
          type : "isIn",
          params : [
            ["self", "minor"]
          ],
          message: "Please choose a relationship"
        }]
      },
      {
        questionId: "EmployeeID",
        question: "EmployeeID",
        input: {
          type: "hiddenInput",
          required: false,
          options: [
            {
              value: sessionStorage.getItem(LOGGED_IN_USER_KEY),
              name: "EmployeeID",
              state: "OK"
            }
          ]
        }
      }
    ]
  },
  {
    questionSetId: "request-type-set",
    questions: [
      {
        questionId: "RequestType",
        question: "Select a request type below",
        input: {
          type: "checkboxOptionsInput",
          required: true,
          options: [
            {
              text: "Personal Information Report",
              value: "pir",
              name: "pir",
              state: "OK"
            },
            {
              text: "Correct Personal Information",
              value: "correct",
              name: "correct",
              state: "OK"
            },
            {
              text: "Do Not Sell My Personal Information",
              name: "optout",
              value: "optout",
              state: "OK"
            },
            {
              text: "Delete My Personal Information",
              name: "delete",
              value: "delete",
              state: "OK"
            },
            {
              text: "Do Not Share My Personal Information for Cross-Context Behavioral Advertising*",
              name: "cross-context",
              value: "cross-context",
              state: "OK"
            }
          ]
        },
        validations : [{
          type : "isAllIn",
          params : [
            [
              "pir",
              "correct",
              "optout",
              "delete",
              "cross-context"
            ]
          ],
          message: "Please make a selection"
        }]
      }
    ]
  },
  {
    questionSetId: "report-type-set",
    questions: [
      {
        questionId: "ReportType",
        question: "Please select one option below",
        input: {
          type: "radioOptionsInput",
          required: true,
          options: [
            {
              text: "Email a digital copy to the email address on file",
              value: "digital",
              state: "OK"
            },
            {
              text: "Mail a hard copy to the address on file",
              value: "hardcopy",
              state: "OK"
            }
          ]
        },
        validations : [{
          type : "isIn",
          params : [
            ["digital", "hardcopy"]
          ],
          message: "Please choose a report type"
        }]
      }
    ]
  },
  {
    questionSetId: "pii-set",
    questions: [
      {
        questionId: "FirstName",
        question: "First Name",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              value: "",
              name: "FirstName",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.`- '"],
            message: "Letters and spaces only please"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Please enter a min of 2 and a max of 50 letters of your first name"
          }
        ]
      },
      {
        questionId: "LastName",
        question: "Last Name",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "LastName",
              value: "",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.`- '"],
            message: "Letters and spaces only please"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Please enter a min of 2 and a max of 50 letters of your last name"
          }
        ]
      },
      {
        questionId: "SSN",
        question: "Last 4 digits of your Social Security or Tax ID Number",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              value: "",
              name: "SSN",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isNumeric",
            params : [{ no_symbols: true }],
            message: "Numbers only please"
          },
          {
            type : "isLength",
            params : [{ min: 4, max: 4 }],
            message: "Please enter only the last 4 digits of your social security number"
          }
        ]
      },
      {
        questionId: "dateOfBirth",
        question: "Date of Birth",
        input: {
          type: "dateInput",
          required: true,
          options: [
            {
              value: "",
              name: "dateOfBirth",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isDate",
            message: "Please enter a properly formatted date"
          },
          {
            type : "isDOB",
            message: "Please enter a valid date of birth"
          }
        ]
      }
    ]
  },
  {
    questionSetId: "requestor-pii-set",
    questions: [
      {
        questionId: "FirstName",
        question: "First Name",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              value: " ",
              name: "FirstName",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.`- '"],
            message: "Numbers and spaces only please"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Enter a min of 2 and a max of 50 letters of your first name"
          }
        ]
      },
      {
        questionId: "LastName",
        question: "Last Name",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "LastName",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.`- '"],
            message: "Numbers and spaces only please"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Enter a min of 2 and a max of 50 letters of your last name"
          }
        ]
      },
      {
        questionId: "dateOfBirth",
        question: "Date of Birth",
        input: {
          type: "dateInput",
          required: true,
          options: [
            {
              value: "",
              name: "dateOfBirth",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isDate",
            message: "Please enter a properly formatted date"
          },
          {
            type : "isDOB",
            message: "Please enter a valid date of birth"
          }
        ]
      },
      {
        questionId: "addressLine1",
        question: "Address",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "addressLine1",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890.`- '"],
            message: "Special characters are not allowed"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Please enter a valid street address"
          }
        ]
      },
      {
        questionId: "addressLine2",
        question: "",
        input: {
          type: "textInput",
          required: false,
          options: [
            {
              name: "addressLine2",
              value: " ",
              state: "OK"
            }
          ]
        }
      },
      {
        questionId: "City",
        question: "City",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "City",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890.`- '"],
            message: "Special characters are not allowed"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Please enter a valid city name"
          }
        ]
      },
      {
        questionId: "State",
        question: "State",
        input: {
          type: "selectInput",
          default: 0,
          required: true,
          options: [
            {
                "text": "",
                "value": "",
                "state": "OK"
            },
            {
                "text": "Alabama",
                "value": "AL",
                "state": "OK"
            },
            {
                "text": "Alaska",
                "value": "AK",
                "state": "OK"
            },
            {
                "text": "American Samoa",
                "value": "AS",
                "state": "OK"
            },
            {
                "text": "Arizona",
                "value": "AZ",
                "state": "OK"
            },
            {
                "text": "Arkansas",
                "value": "AR",
                "state": "OK"
            },
            {
                "text": "California",
                "value": "CA",
                "state": "OK"
            },
            {
                "text": "Colorado",
                "value": "CO",
                "state": "OK"
            },
            {
                "text": "Connecticut",
                "value": "CT",
                "state": "OK"
            },
            {
                "text": "Delaware",
                "value": "DE",
                "state": "OK"
            },
            {
                "text": "District Of Columbia",
                "value": "DC",
                "state": "OK"
            },
            {
                "text": "Federated States Of Micronesia",
                "value": "FM",
                "state": "OK"
            },
            {
                "text": "Florida",
                "value": "FL",
                "state": "OK"
            },
            {
                "text": "Georgia",
                "value": "GA",
                "state": "OK"
            },
            {
                "text": "Guam, US-GU",
                "value": "GU",
                "state": "OK"
            },
            {
                "text": "Hawaii",
                "value": "HI",
                "state": "OK"
            },
            {
                "text": "Idaho",
                "value": "ID",
                "state": "OK"
            },
            {
                "text": "Illinois",
                "value": "IL",
                "state": "OK"
            },
            {
                "text": "Indiana",
                "value": "IN",
                "state": "OK"
            },
            {
                "text": "Iowa",
                "value": "IA",
                "state": "OK"
            },
            {
                "text": "Kansas",
                "value": "KS",
                "state": "OK"
            },
            {
                "text": "Kentucky",
                "value": "KY",
                "state": "OK"
            },
            {
                "text": "Louisiana",
                "value": "LA",
                "state": "OK"
            },
            {
                "text": "Maine",
                "value": "ME",
                "state": "OK"
            },
            {
                "text": "Marshall Islands",
                "value": "MH",
                "state": "OK"
            },
            {
                "text": "Maryland",
                "value": "MD",
                "state": "OK"
            },
            {
                "text": "Massachusetts",
                "value": "MA",
                "state": "OK"
            },
            {
                "text": "Michigan",
                "value": "MI",
                "state": "OK"
            },
            {
                "text": "Minnesota",
                "value": "MN",
                "state": "OK"
            },
            {
                "text": "Mississippi",
                "value": "MS",
                "state": "OK"
            },
            {
                "text": "Missouri",
                "value": "MO",
                "state": "OK"
            },
            {
                "text": "Montana",
                "value": "MT",
                "state": "OK"
            },
            {
                "text": "Nebraska",
                "value": "NE",
                "state": "OK"
            },
            {
                "text": "Nevada",
                "value": "NV",
                "state": "OK"
            },
            {
                "text": "New Hampshire",
                "value": "NH",
                "state": "OK"
            },
            {
                "text": "New Jersey",
                "value": "NJ",
                "state": "OK"
            },
            {
                "text": "New Mexico",
                "value": "NM",
                "state": "OK"
            },
            {
                "text": "New York",
                "value": "NY",
                "state": "OK"
            },
            {
                "text": "North Carolina",
                "value": "NC",
                "state": "OK"
            },
            {
                "text": "North Dakota",
                "value": "ND",
                "state": "OK"
            },
            {
                "text": "Northern Mariana Islands",
                "value": "MP",
                "state": "OK"
            },
            {
                "text": "Ohio",
                "value": "OH",
                "state": "OK"
            },
            {
                "text": "Oklahoma",
                "value": "OK",
                "state": "OK"
            },
            {
                "text": "Oregon",
                "value": "OR",
                "state": "OK"
            },
            {
                "text": "Pennsylvania",
                "value": "PA",
                "state": "OK"
            },
            {
                "text": "Puerto Rico, US-PR",
                "value": "PR",
                "state": "OK"
            },
            {
                "text": "Rhode Island",
                "value": "RI",
                "state": "OK"
            },
            {
                "text": "South Carolina",
                "value": "SC",
                "state": "OK"
            },
            {
                "text": "South Dakota",
                "value": "SD",
                "state": "OK"
            },
            {
                "text": "Tennessee",
                "value": "TN",
                "state": "OK"
            },
            {
                "text": "Texas",
                "value": "TX",
                "state": "OK"
            },
            {
                "text": "Utah",
                "value": "UT",
                "state": "OK"
            },
            {
                "text": "Vermont",
                "value": "VT",
                "state": "OK"
            },
            {
                "text": "Virgin Islands, US-VI",
                "value": "VI",
                "state": "OK"
            },
            {
                "text": "Virginia",
                "value": "VA",
                "state": "OK"
            },
            {
                "text": "Washington",
                "value": "WA",
                "state": "OK"
            },
            {
                "text": "West Virginia",
                "value": "WV",
                "state": "OK"
            },
            {
                "text": "Wisconsin",
                "value": "WI",
                "state": "OK"
            },
            {
                "text": "Wyoming",
                "value": "WY",
                "state": "OK"
            }
          ]
        },
        validations : [
          {
            type : "isLength",
            params : [1],
            message: "Please select a state"
          }
        ]
      },
      {
        questionId: "Zipcode",
        question: "Zipcode",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              value: "",
              name: "Zipcode",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isNumeric",
            params : [{ no_symbols: true }],
            message: "Please enter a 5 digit zip code"
          },
          {
            type : "isLength",
            params : [{ min: 5, max: 5 }],
            message: "Zipcode length should not exceed 5 numbers"
          }
        ]
      },
      {
        questionId: "Email",
        question: "Email Address",
        input: {
          type: "emailInput",
          required: true,
          options: [
            {
              name: "Email",
              value: "",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isEmail",
            message: "Please enter a valid email address"
          },
          {
            type : "isLength",
            params : [1],
            message: "Your email address is too long"
          }
        ]
      },
      {
        questionId: "PhoneNumber",
        question: "Phone Number",
        input: {
          type: "phoneInput",
          required: true,
          options: [
            {
              name: "PhoneNumber",
              value: "",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isMobilePhone",
            message: "Please enter a valid phone number"
          },
          {
            type : "isLength",
            params : [10],
            message: "Phone number should be 10 digits"
          }
        ]
      },
      {
        questionId: "RequestorRelationship",
        question: "Your Relationship to Your Child/Dependent",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "RequestorRelationship",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.`- '"],
            message: "Please enter your relationship to the child/dependent"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Your answer is unreadable. Please keep your answer between 2-50 characters"
          }
        ]
      }
    ]
  },
  {
    questionSetId: "contact-set",
    questions: [
      {
        questionId: "addressLine1",
        question: "Address",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "addressLine1",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890.`- '"],
            message: "Special characters are not allowed"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Your address is unreadable"
          }
        ]
      },
      {
        questionId: "addressLine2",
        question: "",
        input: {
          type: "textInput",
          required: false,
          options: [
            {
              name: "addressLine2",
              value: " ",
              state: "OK"
            }
          ]
        }
      },
      {
        questionId: "City",
        question: "City",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "City",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890.`- '"],
            message: "Special characters are not allowed"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Your city name is unreadable"
          }
        ]
      },
      {
        questionId: "State",
        question: "State",
        input: {
          type: "selectInput",
          default: 0,
          required: true,
          options: [
            {
                "text": "",
                "value": "",
                "state": "OK"
            },
            {
                "text": "Alabama",
                "value": "AL",
                "state": "OK"
            },
            {
                "text": "Alaska",
                "value": "AK",
                "state": "OK"
            },
            {
                "text": "American Samoa",
                "value": "AS",
                "state": "OK"
            },
            {
                "text": "Arizona",
                "value": "AZ",
                "state": "OK"
            },
            {
                "text": "Arkansas",
                "value": "AR",
                "state": "OK"
            },
            {
                "text": "California",
                "value": "CA",
                "state": "OK"
            },
            {
                "text": "Colorado",
                "value": "CO",
                "state": "OK"
            },
            {
                "text": "Connecticut",
                "value": "CT",
                "state": "OK"
            },
            {
                "text": "Delaware",
                "value": "DE",
                "state": "OK"
            },
            {
                "text": "District Of Columbia",
                "value": "DC",
                "state": "OK"
            },
            {
                "text": "Federated States Of Micronesia",
                "value": "FM",
                "state": "OK"
            },
            {
                "text": "Florida",
                "value": "FL",
                "state": "OK"
            },
            {
                "text": "Georgia",
                "value": "GA",
                "state": "OK"
            },
            {
                "text": "Guam Gu",
                "value": "GU",
                "state": "OK"
            },
            {
                "text": "Hawaii",
                "value": "HI",
                "state": "OK"
            },
            {
                "text": "Idaho",
                "value": "ID",
                "state": "OK"
            },
            {
                "text": "Illinois",
                "value": "IL",
                "state": "OK"
            },
            {
                "text": "Indiana",
                "value": "IN",
                "state": "OK"
            },
            {
                "text": "Iowa",
                "value": "IA",
                "state": "OK"
            },
            {
                "text": "Kansas",
                "value": "KS",
                "state": "OK"
            },
            {
                "text": "Kentucky",
                "value": "KY",
                "state": "OK"
            },
            {
                "text": "Louisiana",
                "value": "LA",
                "state": "OK"
            },
            {
                "text": "Maine",
                "value": "ME",
                "state": "OK"
            },
            {
                "text": "Marshall Islands",
                "value": "MH",
                "state": "OK"
            },
            {
                "text": "Maryland",
                "value": "MD",
                "state": "OK"
            },
            {
                "text": "Massachusetts",
                "value": "MA",
                "state": "OK"
            },
            {
                "text": "Michigan",
                "value": "MI",
                "state": "OK"
            },
            {
                "text": "Minnesota",
                "value": "MN",
                "state": "OK"
            },
            {
                "text": "Mississippi",
                "value": "MS",
                "state": "OK"
            },
            {
                "text": "Missouri",
                "value": "MO",
                "state": "OK"
            },
            {
                "text": "Montana",
                "value": "MT",
                "state": "OK"
            },
            {
                "text": "Nebraska",
                "value": "NE",
                "state": "OK"
            },
            {
                "text": "Nevada",
                "value": "NV",
                "state": "OK"
            },
            {
                "text": "New Hampshire",
                "value": "NH",
                "state": "OK"
            },
            {
                "text": "New Jersey",
                "value": "NJ",
                "state": "OK"
            },
            {
                "text": "New Mexico",
                "value": "NM",
                "state": "OK"
            },
            {
                "text": "New York",
                "value": "NY",
                "state": "OK"
            },
            {
                "text": "North Carolina",
                "value": "NC",
                "state": "OK"
            },
            {
                "text": "North Dakota",
                "value": "ND",
                "state": "OK"
            },
            {
                "text": "Northern Mariana Islands",
                "value": "MP",
                "state": "OK"
            },
            {
                "text": "Ohio",
                "value": "OH",
                "state": "OK"
            },
            {
                "text": "Oklahoma",
                "value": "OK",
                "state": "OK"
            },
            {
                "text": "Oregon",
                "value": "OR",
                "state": "OK"
            },
            {
                "text": "Palau",
                "value": "PW",
                "state": "OK"
            },
            {
                "text": "Pennsylvania",
                "value": "PA",
                "state": "OK"
            },
            {
                "text": "Puerto Rico",
                "value": "PR",
                "state": "OK"
            },
            {
                "text": "Rhode Island",
                "value": "RI",
                "state": "OK"
            },
            {
                "text": "South Carolina",
                "value": "SC",
                "state": "OK"
            },
            {
                "text": "South Dakota",
                "value": "SD",
                "state": "OK"
            },
            {
                "text": "Tennessee",
                "value": "TN",
                "state": "OK"
            },
            {
                "text": "Texas",
                "value": "TX",
                "state": "OK"
            },
            {
                "text": "Utah",
                "value": "UT",
                "state": "OK"
            },
            {
                "text": "Vermont",
                "value": "VT",
                "state": "OK"
            },
            {
                "text": "Virgin Islands",
                "value": "VI",
                "state": "OK"
            },
            {
                "text": "Virginia",
                "value": "VA",
                "state": "OK"
            },
            {
                "text": "Washington",
                "value": "WA",
                "state": "OK"
            },
            {
                "text": "West Virginia",
                "value": "WV",
                "state": "OK"
            },
            {
                "text": "Wisconsin",
                "value": "WI",
                "state": "OK"
            },
            {
                "text": "Wyoming",
                "value": "WY",
                "state": "OK"
            }
          ]
        },
        validations : [
          {
            type : "isLength",
            params : [1],
            message: "Please select a state"
          }
        ]
      },
      {
        questionId: "Zipcode",
        question: "Zipcode",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              value: "",
              name: "Zipcode",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isNumeric",
            params : [{ no_symbols: true }],
            message: "Numbers Only Please"
          },
          {
            type : "isLength",
            params : [{ min: 5, max: 5 }],
            message: "Please enter a 5 digit zip code"
          }
        ]
      },
      {
        questionId: "Email",
        question: "Email Address",
        input: {
          type: "emailInput",
          required: true,
          options: [
            {
              name: "Email",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isEmail",
            message: "Please enter a valid email address"
          },
          {
            type : "isLength",
            params : [1],
            message: "Your email is too long"
          }
        ]
      },
      {
        questionId: "PhoneNumber",
        question: "Phone Number",
        input: {
          type: "phoneInput",
          required: true,
          options: [
            {
              name: "PhoneNumber",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isMobilePhone",
            message: "Please enter a valid phone number"
          },
          {
            type : "isLength",
            params : [10],
            message: "Please enter all 10 digits"
          }
        ]
      }
    ]
  },
  {
    questionSetId: "minor-contact-set",
    questions: [
      {
        questionId: "ChildAddress",
        question: "Child/Dependent's Address",
        input: {
          type: "addressInput",
          required: true,
          options: [
            {
              name: "ChildAddress",
              value: " ",
              state: "OK"
            }
          ]
        }
      }
    ]
  },
  {
    questionSetId: "pii-minor-set",
    questions: [
      {
        questionId: "ChildFirstName",
        question: "Child/Dependent's First Name",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "ChildFirstName",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.`- '"],
            message: "Letters and spaces only please"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Please enter a min of 2 and a max of 50 letters of your child's first name"
          }
        ]
      },
      {
        questionId: "ChildLastName",
        question: "Child/Dependent's Last Name",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "ChildLastName",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.`- '"],
            message: "Letters and spaces only please"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Please enter a min of 2 and a max of 50 letters of your child's last name"
          }
        ]
      },

      {
        questionId: "ChildSSN",
        question: "Last 4 digits of your Child/Dependent's Social Security or Tax ID Number",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "ChildSSN",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isNumeric",
            params : [{ no_symbols: true }],
            message: "Numbers only please"
          },
          {
            type : "isLength",
            params : [{ min: 4, max: 4 }],
            message: "Please enter only the last 4 digits of your Social Security Number"
          }
        ]
      },
      {
        questionId: "childDOB",
        question: "Child/Minor Date of Birth",
        input: {
          type: "dateInput",
          required: true,
          options: [
            {
              value: "",
              name: "childDOB",
              state: "OK"
            }
          ]
        },
        validations : [
        {
            type : "isDate",
            message: "Please use a properly formatted date"
          },
          {
            type : "isDOB",
            message: "Please enter a valid date of birth"
          }
        ]
      },
      {
        questionId: "ChildRelationship",
        question: "Child/Dependent's Relationship to You",
        input: {
          type: "textInput",
          required: true,
          options: [
            {
              name: "ChildRelationship",
              value: " ",
              state: "OK"
            }
          ]
        },
        validations : [
          {
            type : "isWhitelisted",
            params: ["abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.`- '"],
            message: "Letters and spaces only please"
          },
          {
            type : "isLength",
            params : [{ min: 2, max: 50 }],
            message: "Please enter your child/dependent relationship to you"
          }
        ]
      }
    ]
  }
];

export default questions;
